export const acropolisGreekIslandsProgram = {
  programKey: 'z-akropolu-ku-greckim-wyspom',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Z Akropolu ku greckim wyspom',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Grecja:',
  stickySubtitle: 'Z Akropolu ku greckim wyspom',

  /* Adres uzupełnimy przed odsłonięciem programu w katalogu. */
  pageUrl: '',

  catalog: {
    enabled: false,
    image: '',
    heroImageFallback: '',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Ateny'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '',
  },

  /* Terminy: 12 - 15 maja oraz 11 - 14 listopada 2027. */
  tripIds: [39, 40],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '39': {
      pilotId: 'marta',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż odbywa się między Lotniskiem Chopina w Warszawie (WAW) a lotniskiem w Atenach (ATH).',
        },
        hotel: {
          title: 'Hotel 3★ w centrum Aten',
          description:
            '3 noclegi w pokojach 2-osobowych z prywatną łazienką w hotelu 3★ w centrum Aten. W cenie są śniadania hotelowe.',
        },
      },
    },

    '40': {
      pilotId: 'marta',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż odbywa się między Lotniskiem Chopina w Warszawie (WAW) a lotniskiem w Atenach (ATH).',
        },
        hotel: {
          title: 'Hotel 3★ w centrum Aten',
          description:
            '3 noclegi w pokojach 2-osobowych z prywatną łazienką w hotelu 3★ w centrum Aten. W cenie są śniadania hotelowe.',
        },
      },
    },
  },
}
